import * as callApi from '../utils/apiHelper';
import api from '../commons/environment';

export const updateTrendingView = (data) => {
    const url = api.trendingView;
    return callApi.post(url, data);
}